<div class="logout-loader-modal">
   <div class="loader"></div>
   <h2 class="header-class" [innerHTML]="translation['home.loader.heading']"></h2>
   <span class="description" [innerHTML]="translation['home.loader.description']"></span>
</div>